/**
 * Normaliza um nome para uso em classes CSS
 * - Converte para minúsculas
 * - Substitui espaços por underscore
 * - Remove caracteres especiais (mantém apenas letras, números e underscore)
 */
function normalizeCssClassName(name: string): string {
  return name
    .toLowerCase()
    .replace(/\s+/g, '_') // Substitui espaços por underscore
    .replace(/[^a-z0-9_]/g, '') // Remove caracteres especiais, mantém apenas letras, números e underscore
    .replace(/_+/g, '_') // Remove underscores duplicados
    .replace(/^_+|_+$/g, ''); // Remove underscores no início e fim
}

/**
 * Gera automaticamente uma classe CSS baseada no nome da seção e propriedade
 * Formato: {sectionName}_{propName}[_index]
 */
export function generateCssClass(sectionName: string, propName: string, arrayIndex?: number): string {
  const suffix = typeof arrayIndex === 'number' ? `_${arrayIndex + 1}` : ''
  const className = `${normalizeCssClassName(sectionName)}_${normalizeCssClassName(propName)}${suffix}`
  
  return className
}

/**
 * Atualiza o valor de uma propriedade para incluir a classe CSS gerada automaticamente
 */
export function updatePropertyWithClass(
  sectionName: string, 
  propName: string, 
  currentValue: any, 
  newValue: any,
  arrayIndex?: number
): any {
  const cssClass = generateCssClass(sectionName, propName, arrayIndex);
  const shouldForceClass = typeof arrayIndex === 'number'
  const pickClass = (existing?: string) => shouldForceClass ? cssClass : (existing || cssClass)
  
  // Se o valor atual é um objeto com value e style
  if (currentValue && typeof currentValue === 'object' && currentValue.value !== undefined) {
    return {
      ...currentValue,
      ...newValue,
      class: pickClass(currentValue.class) // Forçar classe indexada para arrays
    };
  }
  
  // Se o valor atual é um objeto com style
  if (currentValue && typeof currentValue === 'object' && currentValue.style !== undefined) {
    return {
      ...currentValue,
      ...newValue,
      class: pickClass(currentValue.class)
    };
  }
  
  // Se o novo valor é um objeto
  if (newValue && typeof newValue === 'object') {
    return {
      ...newValue,
      class: pickClass(currentValue?.class)
    };
  }
  
  // Se é um valor simples, criar estrutura padrão
  return {
    value: newValue,
    style: '',
    class: pickClass(currentValue?.class)
  };
}

/**
 * Verifica se uma propriedade precisa de classe CSS
 */
export function needsCssClass(propType: string): boolean {
  const typesThatNeedCss = ['text', 'color', 'button', 'image'];
  return typesThatNeedCss.includes(propType);
}
